<template>
  <div>
    <b-sidebar
      id="sidebar-Fee"
      bg-variant="white"
      v-model="visibility"
      sidebar-class="sidebar-lg"
      right
      no-header
      backdrop
      shadow
    >
      <div
        class="d-flex justify-content-between align-items-center content-sidebar-header px-2 py-1"
      >
        <h5 class="mb-0">{{ $t("Checklist") }}</h5>
        <feather-icon
          class="ml-1 cursor-pointer"
          icon="XIcon"
          size="16"
          @click="hideSideBar()"
        />
      </div>

      <b-form class="p-2" @submit.prevent>
        <b-row class="d-flex align-items-center">
          <b-col md="10">
            <b-form-group
              :label="$t('Title')"
              :invalid-feedback="$t('Title is required')"
            >
              <b-form-input
                ref="title"
                v-model="checkObj.title"
                :placeholder="$t('Enter title')"
                @focusout="checkTitle()"
              >
              </b-form-input>
            </b-form-group>
          </b-col>
          <b-col md="2">
            <b-button
              variant="success"
              class="btn-icon mr-0 mr-sm-1 mb-1 mb-sm-0"
              @click="Save()"
              :disabled="saving"
            >
              <b-spinner v-if="saving" small type="grow" />
              <feather-icon v-else :icon="accIcon" />
            </b-button>
          </b-col>
        </b-row>
        <b-table
          class="mt-1"
          show-empty
          :items="allChecklist"
          :fields="fields"
          responsive
          hover
          small
        >
          <template #head()="scope">
            <div :class="scope.label == 'actions' && 'text-right'">
              {{ $t(scope.label) }}
            </div>
          </template>

          <template #cell(actions)="data">
            <div class="text-right">
              <b-button
                variant="primary"
                class="btn-icon mr-1"
                @click="editCL(data.item)"
              >
                <feather-icon icon="EditIcon" />
              </b-button>
              <b-button
                variant="outline-danger"
                class="btn-icon"
                @click="deleteCL(data.item)"
              >
                <feather-icon icon="Trash2Icon" />
              </b-button>
            </div>
          </template>
        </b-table>
        <!-- <b-row>
            <b-col
              style="border-bottom: 2px solid lightgray"
              v-if="accTypes.length > 0"
              class="d-flex align-items-center justify-content-between mb-1 pb-1 pt-1"
              md="12"
              v-for="acc in accTypes"
              :key="acc.id"
            >
              <h6 class="mr-1">{{ acc.account }}</h6>
              <div>
                <b-button
                  variant="primary"
                  class="btn-icon mr-0 mr-sm-1 mb-1 mb-sm-0"
                  @click="editAcc(acc)"
                >
                  <feather-icon icon="EditIcon" />
                </b-button>
                <b-button
                  variant="outline-danger"
                  class="btn-icon mr-0 mr-sm-1 mb-1 mb-sm-0"
                  @click="deleteAcc(acc)"
                >
                  <feather-icon icon="Trash2Icon" />
                </b-button>
              </div>
            </b-col>
            <b-col md="12" v-else class="text-center">
              <h4>No Records Found</h4>
            </b-col>
          </b-row> -->
      </b-form>
      <sidebar-content />
    </b-sidebar>
    <b-col md="12">
      <h3 class="mb-75">
        {{
          myObj.inquiryType == "visitor"
            ? $t("Visitor Inquiry Form")
            : $t("Student Inquiry Form")
        }}
      </h3>
    </b-col>
    <b-card class="">
      <b-row class="">
        <b-col xl="3" lg="3" md="4" sm="12" cols="12">
          <b-form-group
            :invalid-feedback="$t('Name is required')"
            label-class="font-weight-bold"
          >
            <template #label>
              <inquiry-required-label
                :text="$t('Name')"
                :required="true"
                :red="true"
              />
            </template>
            <b-form-input
              :placeholder="$t('Enter student name')"
              ref="name"
              v-model.trim="myObj.name"
              @focusout="CheckName()"
            />
          </b-form-group>
        </b-col>
        <b-col xl="3" lg="3" md="4" sm="12" cols="12">
          <b-form-group
            :invalid-feedback="$t('Father name is required')"
            label-class="font-weight-bold"
          >
            <template #label>
              <inquiry-required-label
                :text="$t('Father name')"
                :required="true"
                :red="true"
              />
            </template>
            <b-form-input
              :placeholder="$t('Enter student father name')"
              ref="fname"
              v-model.trim="myObj.father_name"
              @focusout="CheckFName()"
            />
          </b-form-group>
        </b-col>
        <b-col
          v-if="showVisitorExtendedFields || showCrestViewInquiryFields"
          xl="3"
          lg="3"
          md="4"
          sm="12"
          cols="12"
        >
          <b-form-group
            :invalid-feedback="$t('Current class is required.')"
            label-class="font-weight-bold"
            ref="current_class"
          >
            <template #label>
              <inquiry-required-label
                :text="$t('Current class')"
                :required="requireCrestViewFields"
              />
            </template>
            <v-select
              v-model="myObj.currentClass"
              :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
              :options="classes"
              :clearable="true"
              :reduce="(val) => val.name"
              label="name"
              :placeholder="$t('Select current class')"
            />
          </b-form-group>
        </b-col>
        <b-col
          v-if="showVisitorExtendedFields || myObj.inquiryType != 'visitor'"
          xl="3"
          lg="3"
          md="4"
          sm="12"
          cols="12"
        >
          <b-form-group
            :invalid-feedback="$t('Class is required')"
            label-class="font-weight-bold"
            ref="class"
          >
            <template #label>
              <inquiry-required-label
                :text="gradeClassLabel"
                :required="
                  requireCrestViewFields ||
                  (!isCrestViewAcademy && showCrestViewGradeFields) ||
                  myObj.inquiryType != 'visitor'
                "
                :red="requireCrestViewFields"
              />
            </template>
            <v-select
              v-model="myObj.cls"
              :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
              :options="classes"
              :clearable="false"
              :reduce="(val) => val.id"
              label="name"
              :placeholder="gradeClassPlaceholder"
              @input="onClassSelected()"
            />
          </b-form-group>
        </b-col>
        <b-col
          v-if="
            isHasanIslamicInquiry &&
            (showVisitorExtendedFields || myObj.inquiryType != 'visitor')
          "
          xl="3"
          lg="3"
          md="4"
          sm="12"
          cols="12"
        >
          <b-form-group
            :invalid-feedback="$t('Section is required.')"
            label-class="font-weight-bold"
            ref="section"
          >
            <template #label>
              <inquiry-required-label
                :text="$t('Section')"
                :required="sectionOptions.length > 0"
                :red="sectionOptions.length > 0"
              />
            </template>
            <v-select
              v-model="myObj.sec"
              :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
              :options="sectionOptions"
              :clearable="false"
              :reduce="(val) => val.id"
              label="section"
              :disabled="!myObj.cls || !sectionOptions.length"
              :placeholder="$t('Select section')"
              @input="checkSection()"
            />
          </b-form-group>
        </b-col>
        <b-col
          v-if="
            myObj.inquiryType == 'visitor' && !showVisitorExtendedFields
          "
          xl="3"
          lg="3"
          md="4"
          sm="12"
          cols="12"
        >
          <b-form-group
            :label="$t('CNIC')"
            :invalid-feedback="$t('CNIC is required')"
            ref="cnic"
          >
            <b-form-input
              ref="cnic"
              :placeholder="$t('Enter visitor\'s cnic')"
              v-model="myObj.cnic"
            />
          </b-form-group>
        </b-col>

        <b-col
          xl="3"
          lg="3"
          md="4"
          sm="12"
          cols="12"
          v-if="myObj.inquiryType == 'inquiry' && !showCrestViewInquiryFields"
        >
          <b-form-group
            :label="$t('Age')"
            :invalid-feedback="$t('Age is required.')"
            ref="age"
          >
            <b-form-input :placeholder="$t('Enter age')" v-model="myObj.age" />
          </b-form-group>
        </b-col>

        <b-col xl="3" lg="3" md="4" sm="12" cols="12">
          <b-form-group
            :invalid-feedback="$t('Please enter correct phone number')"
            label-class="font-weight-bold"
          >
            <template #label>
              <inquiry-required-label
                :text="$t('Contact number')"
                :required="true"
                :red="true"
              />
            </template>
            <vue-tel-input
              v-model="myObj.contact"
              :dropdownOptions="dropOptions"
              :defaultCountry="$store.state.countryCode"
              @input="CheckMobile"
            ></vue-tel-input>
            <small class="mr-1 text-danger" v-if="contacterror">{{
              $t("Contact number is required")
            }}</small>
          </b-form-group>
        </b-col>

        <b-col xl="3" lg="3" md="4" sm="12" cols="12">
          <b-form-group
            :invalid-feedback="$t('Email address is required.')"
            ref="email"
          >
            <template #label>
              <inquiry-required-label
                :text="$t('Email')"
                :required="requireCrestViewFields"
              />
            </template>
            <b-form-input
              type="email"
              id="mc-email"
              :placeholder="emailPlaceHolder"
              v-model="myObj.email"
            />
            <!-- @focusout="CheckEmail()" -->
          </b-form-group>
        </b-col>
        <b-col xl="3" lg="3" md="4" sm="12" cols="12">
          <b-form-group
            :invalid-feedback="$t('Date is required')"
            ref="date"
          >
            <template #label>
              <inquiry-required-label
                :text="$t('Date')"
                :required="requireCrestViewFields"
              />
            </template>
            <flat-pickr
              v-model="myObj.date"
              :config="config"
              class="form-control"
              :placeholder="$t('Select Date')"
            />
          </b-form-group>
        </b-col>

        <b-col
          xl="3"
          lg="3"
          md="4"
          sm="12"
          cols="12"
          v-if="myObj.inquiryType == 'visitor'"
        >
          <b-form-group
            :invalid-feedback="$t('Visiting Time is required.')"
            ref="visiting_time"
          >
            <template #label>
              <inquiry-required-label
                :text="$t('Visiting Time')"
                :required="requireCrestViewFields"
              />
            </template>
            <flat-pickr
              v-model="myObj.visitingTime"
              :config="config2"
              class="form-control"
              :placeholder="$t('Select time')"
            />
          </b-form-group>
        </b-col>

        <b-col xl="3" lg="3" md="4" sm="12" cols="12">
          <b-form-group
            :invalid-feedback="$t('Purpose is required.')"
            ref="purpose"
          >
            <template #label>
              <inquiry-required-label
                :text="$t('Purpose')"
                :required="requireCrestViewFields"
              />
            </template>
            <b-form-input
              type="text"
              id="mc-purpose"
              :placeholder="$t('Enter purpose here')"
              v-model="myObj.purpose"
            />
            <!-- @focusout="CheckPurpose()" -->
          </b-form-group>
        </b-col>

        <b-col xl="3" lg="3" md="4" sm="12" cols="12">
          <b-form-group
            :invalid-feedback="$t('Tag is required.')"
            ref="tag"
          >
            <template #label>
              <inquiry-required-label
                :text="$t('Tag')"
                :required="requireCrestViewFields"
              />
            </template>
            <b-form-input
              :placeholder="$t('Enter tag here')"
              v-model="myObj.tag"
            />
            <!-- @focusout="CheckTag()" -->
          </b-form-group>
        </b-col>
        <b-col xl="3" lg="3" md="4" sm="12" cols="12">
          <b-form-group
            :invalid-feedback="$t('Next follow up date is required')"
            ref="next_date"
          >
            <template #label>
              <inquiry-required-label
                :text="$t('Next follow up date')"
                :required="requireCrestViewFields"
              />
            </template>
            <flat-pickr
              ref="next_date"
              v-model="myObj.nextFollowup"
              :config="config"
              class="form-control"
              :placeholder="$t('Select Date')"
            />
          </b-form-group>
        </b-col>
        <template v-if="myObj.inquiryType == 'visitor'">
          <b-col xl="3" lg="3" md="4" sm="12" cols="12">
            <b-form-group
              :invalid-feedback="$t('Meeting with is required')"
              ref="meeting_with"
            >
              <template #label>
                <inquiry-required-label
                  :text="$t('Meeting with')"
                  :required="requireCrestViewFields"
                />
              </template>
              <b-form-input
                :placeholder="$t('Enter meeting with')"
                v-model="myObj.meetingWith"
              />
            </b-form-group>
          </b-col>
          <template v-if="showVisitorExtendedFields">
            <b-col xl="3" lg="3" md="4" sm="12" cols="12">
              <b-form-group
                :invalid-feedback="$t('Date of birth is required.')"
                label-class="font-weight-bold"
                ref="dob"
              >
                <template #label>
                  <inquiry-required-label
                    :text="$t('Date of birth')"
                    :required="requireCrestViewFields"
                  />
                </template>
                <flat-pickr
                  v-model="myObj.dob"
                  :config="config"
                  class="form-control"
                  :placeholder="$t('Select date of birth')"
                  @on-change="onDobChange"
                />
              </b-form-group>
            </b-col>
            <b-col xl="3" lg="3" md="4" sm="12" cols="12">
              <b-form-group
                :invalid-feedback="$t('Age is required.')"
                ref="age"
              >
                <template #label>
                  <inquiry-required-label
                    :text="$t('Age')"
                    :required="requireCrestViewFields"
                  />
                </template>
                <b-form-input
                  :placeholder="$t('Enter age')"
                  v-model="myObj.age"
                />
              </b-form-group>
            </b-col>
            <b-col xl="3" lg="3" md="4" sm="12" cols="12">
              <b-form-group
                :invalid-feedback="$t('Learning difficulties is required.')"
                ref="learning_difficulties"
              >
                <template #label>
                  <inquiry-required-label
                    :text="$t('Learning difficulties')"
                    :required="requireCrestViewFields"
                  />
                </template>
                <b-form-textarea
                  rows="2"
                  :placeholder="$t('Enter learning difficulties (if any)')"
                  v-model.trim="myObj.learningDifficulties"
                />
              </b-form-group>
            </b-col>
            <b-col xl="3" lg="3" md="4" sm="12" cols="12">
              <b-form-group
                :invalid-feedback="$t('Special medical needs is required.')"
                ref="special_medical_needs"
              >
                <template #label>
                  <inquiry-required-label
                    :text="$t('Special medical needs')"
                    :required="requireCrestViewFields"
                  />
                </template>
                <b-form-textarea
                  rows="2"
                  :placeholder="$t('Enter special medical needs (if any)')"
                  v-model.trim="myObj.specialMedicalNeeds"
                />
              </b-form-group>
            </b-col>
          </template>
        </template>

        <template v-if="myObj.inquiryType == 'inquiry'">
          <template v-if="showCrestViewInquiryFields">
            <b-col xl="3" lg="3" md="4" sm="12" cols="12">
              <b-form-group
                :invalid-feedback="$t('Date of birth is required.')"
                label-class="font-weight-bold"
                ref="dob"
              >
                <template #label>
                  <inquiry-required-label
                    :text="$t('Date of birth')"
                    :required="requireCrestViewFields"
                  />
                </template>
                <flat-pickr
                  v-model="myObj.dob"
                  :config="config"
                  class="form-control"
                  :placeholder="$t('Select date of birth')"
                  @on-change="onDobChange"
                />
              </b-form-group>
            </b-col>
            <b-col xl="3" lg="3" md="4" sm="12" cols="12">
              <b-form-group
                :invalid-feedback="$t('Age is required.')"
                ref="age"
              >
                <template #label>
                  <inquiry-required-label
                    :text="$t('Age')"
                    :required="requireCrestViewFields"
                  />
                </template>
                <b-form-input
                  :placeholder="$t('Enter age')"
                  v-model="myObj.age"
                />
              </b-form-group>
            </b-col>
            <b-col xl="3" lg="3" md="4" sm="12" cols="12">
              <b-form-group
                :invalid-feedback="$t('Learning difficulties is required.')"
                ref="learning_difficulties"
              >
                <template #label>
                  <inquiry-required-label
                    :text="$t('Learning difficulties')"
                    :required="requireCrestViewFields"
                  />
                </template>
                <b-form-textarea
                  rows="2"
                  :placeholder="$t('Enter learning difficulties (if any)')"
                  v-model.trim="myObj.learningDifficulties"
                />
              </b-form-group>
            </b-col>
            <b-col xl="3" lg="3" md="4" sm="12" cols="12">
              <b-form-group
                :invalid-feedback="$t('Special medical needs is required.')"
                ref="special_medical_needs"
              >
                <template #label>
                  <inquiry-required-label
                    :text="$t('Special medical needs')"
                    :required="requireCrestViewFields"
                  />
                </template>
                <b-form-textarea
                  rows="2"
                  :placeholder="$t('Enter special medical needs (if any)')"
                  v-model.trim="myObj.specialMedicalNeeds"
                />
              </b-form-group>
            </b-col>
            <b-col xl="3" lg="3" md="4" sm="12" cols="12">
              <b-form-group
                :invalid-feedback="$t('Father\'s occupation is required.')"
                ref="father_occupation"
              >
                <template #label>
                  <inquiry-required-label
                    :text="$t('Father\'s occupation')"
                    :required="requireCrestViewFields"
                  />
                </template>
                <b-form-input
                  v-model.trim="myObj.father_occupation"
                  :placeholder="$t('Enter father\'s occupation')"
                />
              </b-form-group>
            </b-col>
            <b-col xl="3" lg="3" md="4" sm="12" cols="12">
              <b-form-group
                :invalid-feedback="$t('Mother\'s occupation is required.')"
                ref="mother_occupation"
              >
                <template #label>
                  <inquiry-required-label
                    :text="$t('Mother\'s occupation')"
                    :required="requireCrestViewFields"
                  />
                </template>
                <b-form-input
                  v-model.trim="myObj.mother_occupation"
                  :placeholder="$t('Enter mother\'s occupation')"
                />
              </b-form-group>
            </b-col>
            <b-col xl="3" lg="3" md="4" sm="12" cols="12">
              <b-form-group
                :invalid-feedback="$t('Father\'s CNIC is required.')"
                ref="father_cnic"
              >
                <template #label>
                  <inquiry-required-label
                    :text="$t('Father\'s CNIC Number')"
                    :required="requireCrestViewFields"
                  />
                </template>
                <b-form-input
                  v-model="myObj.father_cnic"
                  v-mask="'#####-#######-#'"
                  maxlength="15"
                  :placeholder="$t('XXXXX-XXXXXXX-X')"
                />
              </b-form-group>
            </b-col>
            <b-col xl="3" lg="3" md="4" sm="12" cols="12">
              <b-form-group
                :invalid-feedback="$t('Mother\'s CNIC is required.')"
                ref="mother_cnic"
              >
                <template #label>
                  <inquiry-required-label
                    :text="$t('Mother\'s CNIC Number')"
                    :required="requireCrestViewFields"
                  />
                </template>
                <b-form-input
                  v-model="myObj.mother_cnic"
                  v-mask="'#####-#######-#'"
                  maxlength="15"
                  :placeholder="$t('XXXXX-XXXXXXX-X')"
                />
              </b-form-group>
            </b-col>
          </template>
          <b-col xl="3" lg="3" md="4">
            <b-form-group
              :invalid-feedback="$t('Session is required')"
              ref="session"
            >
              <template #label>
                <inquiry-required-label
                  :text="$t('Session')"
                  :required="requireCrestViewFields"
                />
              </template>
              <v-select
                v-model="myObj.sessionID"
                :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                :options="sessionData"
                :reduce="(val) => val.id"
                label="session"
                :clearable="false"
                :placeholder="$t('Select session')"
              />
            </b-form-group>
          </b-col>
          <b-col xl="6" lg="6" md="8" sm="12" cols="12">
            <b-form-group
              :invalid-feedback="lastInstitutionInvalidFeedback"
              label-class="font-weight-bold"
              ref="last_school"
            >
              <template #label>
                <inquiry-required-label
                  :text="lastInstitutionLabel"
                  :required="true"
                  :red="true"
                />
              </template>
              <b-form-input
                :placeholder="lastInstitutionPlaceholder"
                v-model.trim="myObj.lastSchool"
              />
            </b-form-group>
          </b-col>
          <b-col xl="3" lg="3" md="4">
            <b-form-group
              :invalid-feedback="$t('Last Monthly Fee is required.')"
              ref="last_fee"
            >
              <template #label>
                <inquiry-required-label
                  :text="$t('Last Monthly Fee')"
                  :required="requireCrestViewFields"
                />
              </template>
              <b-form-input
                :placeholder="$t('Enter last monthly fee.')"
                v-model="myObj.lastMonthlyFee"
              />
            </b-form-group>
          </b-col>
          <b-col xl="3" lg="3" md="4">
            <b-form-group
              :invalid-feedback="$t('Studying Since is required.')"
              ref="studying_since"
            >
              <template #label>
                <inquiry-required-label
                  :text="$t('Studying Since')"
                  :required="requireCrestViewFields"
                />
              </template>
              <b-form-input
                :placeholder="$t('Enter studying since')"
                v-model="myObj.studyingSince"
              />
            </b-form-group>
          </b-col>
        </template>
        <b-col xl="6" lg="6" md="6" sm="12" cols="12">
          <b-form-group
            :invalid-feedback="$t('Residential Area is required.')"
            ref="area"
          >
            <template #label>
              <inquiry-required-label
                :text="$t('Residential Area')"
                :required="requireCrestViewFields"
              />
            </template>
            <b-form-input
              :placeholder="$t('Enter residential area')"
              v-model="myObj.residentialArea"
            />
          </b-form-group>
        </b-col>
        <b-col
          :xl="showReferenceOtherInput ? 3 : 6"
          :lg="showReferenceOtherInput ? 3 : 6"
          :md="showReferenceOtherInput ? 4 : 6"
          sm="12"
          cols="12"
        >
          <b-form-group
            :invalid-feedback="$t('Reference is required')"
            ref="refer"
          >
            <template #label>
              <inquiry-required-label
                :text="referenceLabel"
                :required="requireCrestViewFields"
              />
            </template>
            <v-select
              v-model="myObj.referenceID"
              :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
              :options="referenceOptions"
              :clearable="false"
              :reduce="(val) => val.id"
              label="name"
              :placeholder="$t('Select reference')"
            />
          </b-form-group>
        </b-col>
        <b-col
          v-if="showReferenceOtherInput"
          xl="3"
          lg="3"
          md="4"
          sm="12"
          cols="12"
        >
          <b-form-group
            :invalid-feedback="$t('Reference is required')"
            ref="reference_other"
          >
            <template #label>
              <inquiry-required-label
                :text="$t('Please specify')"
                :required="requireCrestViewFields"
              />
            </template>
            <b-form-input
              v-model.trim="referenceOtherText"
              :placeholder="$t('Enter reference')"
            />
          </b-form-group>
        </b-col>
        <b-col md="12" cols="12">
          <b-form-group
            :invalid-feedback="$t('Note is required.')"
            ref="inq_note"
          >
            <template #label>
              <inquiry-required-label
                :text="$t('Note')"
                :required="requireCrestViewFields"
              />
            </template>
            <b-form-input
              :placeholder="$t('Enter note')"
              v-model="myObj.note"
            />
          </b-form-group>
        </b-col>
        <b-col md="12" cols="12">
          <b-form-group
            :invalid-feedback="$t('Final Remarks is required.')"
            ref="final_remark"
          >
            <template #label>
              <inquiry-required-label
                :text="$t('Final Remarks')"
                :required="requireCrestViewFields"
              />
            </template>
            <b-form-input
              :placeholder="$t('Enter remarks')"
              v-model="myObj.finalRemarks"
            />
          </b-form-group>
        </b-col>

        <b-col xl="12" cols="12">
          <b-form-group
            :state="nameState"
            :invalid-feedback="$t('Documents are required')"
            :required="requireCrestViewFields"
            ref="docs"
            class=""
          >
            <template #label>
              <inquiry-required-label
                :text="$t('Upload Documents')"
                :required="requireCrestViewFields"
              />
            </template>
            <div class="d-flex flex-wrap">
              <!-- <b-button
              ref="docs"
              @click="$refs.psamplefile.click()"
              variant="primary"
              :disabled="request || mydocloading"
              block
            >
              <b-spinner
                v-if="mydocloading"
                type="grow"
                small
                label="Loading..."
              />
              <span v-else>Upload</span>
            </b-button> -->
              <div
                class="border-dashed d-flex flex-column justify-content-center align-items-center cursor-pointer rounded mr-1 mb-1"
                style="width: 110px; height: 96px"
                @click="$refs.psamplefile.click()"
              >
                <b-spinner
                  v-if="mydocloading"
                  small
                  label="Loading..."
                  variant="primary"
                />
                <feather-icon
                  v-else
                  icon="PlusIcon"
                  size="34"
                  class="text-primary"
                />
              </div>
              <div
                class="border-dashed d-flex flex-column justify-content-center align-items-center cursor-pointer rounded mr-1 mb-1"
                style="width: 110px; height: 96px; position: relative"
                v-for="(file, index) in attachList"
                :key="index"
                @click="openFile(file)"
              >
                <b-avatar
                  size="20"
                  variant="primary"
                  style="position: absolute; top: -5px; right: -5px"
                >
                  <feather-icon
                    icon="XIcon"
                    @click.stop="deleteDocument(index)"
                  />
                </b-avatar>
                <feather-icon
                  :icon="isImage(file) ? 'ImageIcon' : 'FileTextIcon'"
                  size="30"
                  class="text-primary"
                />
              </div>

              <input
                type="file"
                id="psamplefile"
                hidden
                ref="psamplefile"
                multiple
                @change="PsampleAdd()"
              />
            </div>
          </b-form-group>
        </b-col>
        <!-- <b-col>
          <b-badge
            style="margin-bottom: 5px"
            class="p-1"
            v-for="(file, index) in attachList"
            :key="index"
            variant="light-primary"
          >
            <a :href="file" target="_blank" class="text-primary">
              {{ index + 1 + " : " + file.slice(0, 40) }}
            </a>

            <i
              class="text-danger fa fa-trash"
              style="cursor: pointer"
              @click="deleteDocument(index)"
            ></i>
          </b-badge>
          
        </b-col> -->
      </b-row>
      <!-- 
      <b-row align-h="end">
        
       
      </b-row> -->
    </b-card>

    <template v-if="myObj.inquiryType == 'inquiry' && sbObj && sbObj.valueBool">
      <div>
        <h3 class="mb-75">{{ $t("Sibling Information") }}</h3>
      </div>
      <b-card>
        <b-row v-for="(sibling, idx) in siblingInfo" :key="idx">
          <b-col md="4">
            <b-form-group :label="$t('Name')">
              <b-form-input
                v-model.trim="sibling.name"
                :placeholder="$t('Enter name')"
              />
            </b-form-group>
          </b-col>
          <b-col md="3">
            <b-form-group :label="$t('Relation')">
              <b-form-input
                v-model.trim="sibling.relation"
                :placeholder="$t('Enter relation')"
              />
            </b-form-group>
          </b-col>
          <b-col md="5">
            <b-form-group :label="$t('School name')">
              <b-form-input
                v-model.trim="sibling.schoolName"
                :placeholder="$t('Enter school name')"
              />
            </b-form-group>
          </b-col>
          <b-col md="4">
            <b-form-group :label="$t('Class name')">
              <b-form-input
                v-model.trim="sibling.className"
                :placeholder="$t('Enter class name')"
              />
            </b-form-group>
          </b-col>
          <b-col md="2" class="mt-md-2">
            <b-button
              variant="outline-danger"
              class="btn-icon"
              pill
              @click="removeSibling(sibling, idx)"
            >
              <feather-icon icon="XIcon" />
            </b-button>
          </b-col>
        </b-row>

        <div class="text-center">
          <b-badge
            @click="addSibling"
            variant="primary"
            class="cursor-pointer p-50"
          >
            <feather-icon icon="PlusIcon" class="mr-50" />
            <span>{{ $t("Add More") }}</span>
          </b-badge>
        </div>
      </b-card>
    </template>

    <div>
      <h3 class="mb-75">{{ $t("Checklist") }}</h3>
    </div>
    <b-card>
      <b-row class="p-50">
        <b-col xl="11" lg="10" md="9">
          <b-row>
            <b-col
              xl="2"
              lg="3"
              md="4"
              class="p-0"
              v-for="li in formattedCL"
              :key="li"
            >
              <h5>{{ li.title }}</h5>
              <div class="d-flex align-items-center pr-50" style="width: 100%">
                <b-button
                  :variant="li.checkListData ? 'primary' : 'outline-primary'"
                  class="btn-icon rounded-circle mr-50"
                  @click="li.checkListData = !li.checkListData"
                >
                  <feather-icon icon="CheckIcon" size="16" />
                </b-button>

                <b-progress
                  style="width: 100%"
                  class="progress-bar-dark"
                  height="20px"
                  :value="li.checkListData ? '100' : '0'"
                  variant="success"
                ></b-progress>
              </div>
            </b-col>
          </b-row>
        </b-col>
        <b-col xl="1" lg="2" md="3" class="mt-50 p-0">
          <!-- <b-button @click="AddOpen()" variant="primary" class="btn-icon" block>
            <feather-icon icon="PlusIcon" class="" />
            <span style="font-size: 80%">Checklist</span>
          </b-button> -->
          <b-badge
            @click="AddOpen()"
            variant="primary"
            class="cursor-pointer"
            style="float: right"
          >
            <feather-icon icon="PlusIcon" class="" />
            {{ $t("Checklist") }}
          </b-badge>
        </b-col>
      </b-row>
    </b-card>

    <b-col
      md="12"
      class="d-flex align-items-center justify-content-between mb-75"
    >
      <h3 class="mb-0">{{ $t("Follow up") }}</h3>
      <div class="d-flex align-items-center justify-content-between">
        <h4 class="bv-no-focus-ring col-form-label mr-1">
          {{ $t("Notifications") }}:
        </h4>
        <b-form-checkbox v-model="notification" switch @input="setNoti()" />
      </div>
    </b-col>
    <b-card>
      <!-- <b-row>   
        <b-col
          xl="4"
          lg="4"
          md="6"
          sm="8"
          class="d-flex justify-content-between"
        >        
          <b-form-group
            label="Next follow up date"
            invalid-feedback="Next follow up date is required."
            ref="next_date"
          >
            <flat-pickr
              ref="next_date"
              v-model="myObj.nextFollowup"
              :config="config"
              class="form-control"
              :placeholder="$t('Select Date')"
            />
          </b-form-group>
        </b-col>    
      </b-row>
      <hr /> -->
      <b-row
        v-for="(item, ind) in followObj"
        :key="ind"
        style="display: flex; align-items: center"
      >
        <b-col md="2" class="">
          <b-form-group
            :label="$t('Date')"
            :invalid-feedback="$t('Date is required')"
            ref="date"
          >
            <flat-pickr
              ref="date"
              :config="config"
              v-model="item.date"
              class="form-control"
              :placeholder="$t('Select Date')"
            />
            <!-- @on-change="CheckDate()" -->
          </b-form-group>
        </b-col>
        <b-col md="7" class="">
          <b-form-group
            :label="$t('Note')"
            :invalid-feedback="$t('Note is required.')"
            ref="response"
          >
            <b-form-input
              ref="response"
              :placeholder="$t('Enter note here')"
              v-model="item.note"
            />
          </b-form-group>
        </b-col>
        <b-col md="2" class="">
          <b-form-group
            :label="$t('By')"
            :invalid-feedback="$t('User is required.')"
            ref="user"
          >
            <b-form-input
              ref="user"
              :placeholder="$t('Enter user name')"
              v-model="item.followupBy"
            />
            <!-- <v-select
              v-model="item.followupBy"
              :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
              :options="allUsers"
              :clearable="false"
              :reduce="(val) => val.id"
              label="name"
              ref="user"
              placeholder="Select user"
            /> -->
          </b-form-group>
        </b-col>
        <b-col md="1">
          <b-button
            v-if="ind == followObj.length - 1"
            @click="AddDesc()"
            variant="primary"
            class="btn-icon rounded-circle mr-50"
          >
            <feather-icon size="16" icon="PlusIcon" />
          </b-button>
          <b-button
            v-if="followObj.length > 1"
            @click="removeDesc(item, ind)"
            variant="outline-danger"
            class="btn-icon rounded-circle"
          >
            <feather-icon size="16" icon="XIcon" />
          </b-button>
        </b-col>
      </b-row>
    </b-card>
    <b-row align-h="center">
      <b-col md="6">
        <b-button
          v-ripple.400="'rgba(255, 255, 255, 0.15)'"
          type="submit"
          variant="success"
          @click="Add()"
          :disabled="request || saveDisable"
          block
        >
          <b-spinner v-if="request" small type="grow" />
          <span v-else> {{ $t("Save") }} </span>
        </b-button>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import {
  BCard,
  BRow,
  BCol,
  BFormInput,
  BFormTextarea,
  BButton,
  BTable,
  BMedia,
  BAvatar,
  BLink,
  BBadge,
  BDropdown,
  BDropdownItem,
  BPagination,
  BImg,
  VBTooltip,
  BFormCheckbox,
  BFormGroup,
  BForm,
  BContainer,
  BMediaAside,
  BAside,
  BSpinner,
  BCardTitle,
  BCardText,
  BSidebar,
  VBToggle,
  BInputGroupPrepend,
  BInputGroup,
  BProgress,
} from "bootstrap-vue";
import Ripple from "vue-ripple-directive";
import vSelect from "vue-select";
import { Swiper, SwiperSlide } from "vue-awesome-swiper";
import "swiper/css/swiper.css";

import store from "@/store";
//import { ref, onUnmounted } from '@vue/composition-api'
import { avatarText } from "@core/utils/filter";
//import useAllOrdersList from './useAllOrdersList'
//import orderStoreModule from '../allordersStoreModule'
import flatPickr from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";
import { BFormSelect } from "bootstrap-vue";
//import Multiselect from "vue-multiselect";
import VueGallery from "vue-gallery";
import { forEach } from "postcss-rtl/lib/affected-props";
import { TheMask, mask } from "vue-the-mask";
import { mapActions, mapGetters } from "vuex";
import { getUploadedPaths, uploadToMySkool, isImageUrl, getMediaPreviewUrl } from "@/utils/gdriveUpload";

import * as XLSX from "xlsx";
import { defaultInquiryDob, ensureInquiryDob } from "@/utils/inquiryDob";
import { InquiryRequiredLabel } from "@/utils/inquiryRequiredLabel";
import { isHasanIslamicInquiryDb } from "@/utils/inquiryPublicLinks";

const CRESTVIEW_REFERENCE_OTHER_ID = -1;
const CRESTVIEW_DEFAULT_SESSION = "2026-2027";

export default {
  components: {
    //Multiselect,
    TheMask,
    BProgress,
    BInputGroup,
    BCard,
    BRow,
    BBadge,
    BTable,
    BCol,
    //BAvatar,
    BFormInput,
    BFormTextarea,
    BButton,
    BSidebar,
    BFormGroup,
    BInputGroupPrepend,
    BSpinner,
    BFormCheckbox,
    BForm,
    BContainer,
    //BCardTitle,
    //BCardText,
    //BMediaAside,
    //BImg ,
    // BMedia,
    BAvatar,
    BLink,
    // BSpinner,
    //BBadge,
    //BDropdown,
    //BDropdownItem,
    BPagination,
    vSelect,
    flatPickr,
    InquiryRequiredLabel,
    //'gallery': VueGallery
  },
  props: {
    /* modalFilter: {
      type: [String, null],
      default: null,
      },
      modalFilterOptions: {
      type: Array,
      required: true,
      }*/
  },
  directives: {
    "b-tooltip": VBTooltip,
    "b-toggle": VBToggle,
    Ripple,
    mask,
  },
  mounted() {
    window.addEventListener("keydown", this.handleEvent);
  },
  beforeDestroy() {
    window.removeEventListener("keydown", this.handleEvent);
  },
  async created() {
    // console.log(this.$route.params.id);

    if (this.$route.params.id == 0) {
      this.myObj.inquiryType = "inquiry";
      this.currentInq = 0;
    } else if (this.$route.params.id == -1) {
      this.myObj.inquiryType = "visitor";
      this.currentInq = 0;
    } else {
      let data = this.$route.params.id;
      this.currentInq = data.inquiry.id;
      // console.log(this.currentInq);
      this.myObj = data.inquiry;
      this.myObj.dob = ensureInquiryDob(this.myObj.dob);
      if (this.myObj.sec === null || this.myObj.sec === undefined) {
        this.myObj.sec = 0;
      }
      if (this.myObj.attachments !== null && this.myObj.attachments !== "") {
        this.attachList = this.myObj.attachments.split(",");
        // console.log(this.attachList);
      } else this.attachList = [];
      if (data.followups.length > 0) {
        this.followObj = data.followups;
      } else {
        this.followObj = [
          {
            id: 0,
            inquiryID: this.currentInq,
            campusID: this.$store.state.userData.cId,
            date: new Date().toJSON(),
            followupBy: "",
            note: "",
          },
        ];
      }
      // if (data.checklist) {
      //   this.setChecklist(1)
      // }
      // this.Edit(this.$route.params.id);
    }
    // console.log(this.myObj, this.followObj);

    this.LoadClasses();
    this.loadChecklist(0);
    await this.loadRefs();
    if (this.myObj.inquiryType == "inquiry") {
      this.LoadSession();
      this.LoadSettingsAll();
    }
    // this.LoadUsers();

    // let right = {};
    // this.$store.state.menu.forEach((el) => {
    //   el.children.forEach((ch) => {
    //     right[ch.route] = {
    //       view: ch.view,
    //       add: ch.add,
    //       edit: ch.edit,
    //       delete: ch.delete,
    //     };
    //   });
    // });
    // // console.log(right);
    // this.$store.commit("setRights", right);
    // if (!this.$store.state.rights[this.$route.name]) {
    //   // console.log(this.$store.state.rights[this.$route.name]);
    //   this.$router.replace({
    //     name: "misc-not-authorized",
    //   });
    // } else {
    //   this.rights = this.$store.state.rights[this.$route.name];
    //   this.LoadData();
    //   this.LoadClasses();
    // }
  },
  computed: {
    ...mapGetters({ cmbDepartment: "cmbDepartment" }),
    ...mapGetters({ data: "data" }),

    filters: function () {
      return this.items.filter((pro) => {
        return (
          pro.name.toLowerCase().match(this.searchQuery.toLowerCase()) ||
          pro.purpose.toLowerCase().match(this.searchQuery.toLowerCase())
        );
      });
    },
    emailPlaceHolder() {
      let hostname = window.location.hostname;
      if (hostname == "connect.hpgs.pk") {
        return "info@hpgs.edu.pk";
      } else if (hostname.includes("szablc.edu.pk")) {
        return "szabc@example.com";
      }
      return "myskool@example.com";
    },
    showVisitorExtendedFields() {
      return (
        ["myskoolcrestviewacademy", "myskool"].includes(this.reportDomain) &&
        this.myObj.inquiryType === "visitor"
      );
    },
    isCrestViewAcademy() {
      return this.reportDomain === "myskoolcrestviewacademy";
    },
    isInquiryOptional() {
      if (!this.isCrestViewAcademy) {
        return false;
      }
      const rights = this.$store.state.rights || {};
      const fromRights =
        rights["manage-inquiry"] || rights["inquiry"] || {};
      if (fromRights.optional || fromRights.optimal) {
        return true;
      }
      let optional = false;
      (this.$store.state.menu || []).forEach((el) => {
        (el.children || []).forEach((ch) => {
          if (
            ["manage-inquiry", "inquiry"].includes(ch.route) &&
            (ch.optional || ch.optimal)
          ) {
            optional = true;
          }
        });
      });
      return optional;
    },
    // Optional right: Crestview extra fields stay visible, but are not required.
    requireCrestViewFields() {
      return this.isCrestViewAcademy && !this.isInquiryOptional;
    },
    isCrestViewVisitor() {
      return this.isCrestViewAcademy && this.myObj.inquiryType === "visitor";
    },
    showCrestViewInquiryFields() {
      return this.isCrestViewAcademy && this.myObj.inquiryType === "inquiry";
    },
    showCrestViewGradeFields() {
      return this.showVisitorExtendedFields || this.showCrestViewInquiryFields;
    },
    referenceLabel() {
      return this.isCrestViewAcademy
        ? this.$t("How did you hear about Crest view academy")
        : this.$t("How did you hear about us?");
    },
    referenceOptions() {
      if (!this.isCrestViewAcademy) {
        return this.referenceData;
      }

      const hasOther = this.referenceData.some(
        (item) => item.name && item.name.toLowerCase() === "other"
      );
      if (hasOther) {
        return this.referenceData;
      }

      return [
        ...this.referenceData,
        { id: CRESTVIEW_REFERENCE_OTHER_ID, name: this.$t("Other") },
      ];
    },
    showReferenceOtherInput() {
      return (
        this.isCrestViewAcademy &&
        this.myObj.referenceID === CRESTVIEW_REFERENCE_OTHER_ID
      );
    },
    gradeClassLabel() {
      return this.showCrestViewGradeFields
        ? this.$t("Grade applying for")
        : this.$t("Class");
    },
    gradeClassPlaceholder() {
      return this.showCrestViewGradeFields
        ? this.$t("Select grade applying for")
        : this.$t("Select class");
    },
    isHasanIslamicInquiry() {
      if (this.reportDomain === "myskoolhasanislamic") {
        return true;
      }
      return isHasanIslamicInquiryDb(this.$store.state.userData.db);
    },
    lastInstitutionLabel() {
      return this.isHasanIslamicInquiry
        ? this.$t("Last Institution")
        : this.$t("Last School");
    },
    lastInstitutionPlaceholder() {
      return this.isHasanIslamicInquiry
        ? this.$t("Enter last institution name")
        : this.$t("Enter last school name");
    },
    lastInstitutionInvalidFeedback() {
      return this.isHasanIslamicInquiry
        ? this.$t("Last Institution is required")
        : this.$t("Last School is required");
    },
  },
  data() {
    return {
      allUsers: [],
      currentInq: null,

      followObj: [
        {
          id: 0,
          inquiryID: this.currentInq,
          campusID: this.$store.state.userData.cId,
          date: new Date().toJSON(),
          followupBy: "",
          note: "",
        },
      ],
      formattedCL: [
        // {
        //   id: 0,
        //   inquiryID: this.currentInq,
        //   campusID: this.$store.state.userData.cId,
        //   checklistID: 0,
        //   checkListData: false,
        // },
      ],
      visibility2: false,
      currentID: null,
      rights: {},
      classes: [],
      classRows: [],
      sectionOptions: [],
      filterTags: [],
      filterClasses: [],
      filter: {
        clsIDs: [],
        tags: [],
        campusID: this.$store.state.userData.cId,
        db: this.$store.state.userData.db,
      },
      byFilter: false,
      filterLoading: false,
      contacterror: false,
      mydocloading: false,
      saveDisable: false,
      docsloading: "Upload",
      request: false,
      colorDep: [],
      visibility1: false,

      sidebarTitle: "Add Class",
      sidebarButton: "Save",
      buttonIcon: "PlusIcon",
      dataLoading: false,
      departments: [],
      visibility: false,
      logoloading: "",
      searchQuery: "",
      currentPage: 1,
      perPage: 30,
      totalRows: null,

      errors: {
        status: false,
      },
      statusOptions: ["In stock", "Out stock"],
      filterData: "",
      date: {
        range: "",
      },
      index: null,
      cover: "",
      docs: [],
      partners: [],
      fields: [
        { label: "title", key: "title" },
        { key: "actions", label: "actions" },
      ],
      items: [],
      selected: null,
      filterOptions: [
        { text: "Most sold product", value: "mostSold" },
        { text: "Least sold product", value: "leastSold" },
        { text: "Most popular product", value: "mostPopular" },
        { text: "Least popular product", value: "leastPopular" },
        { text: "Most profitable product", value: "mostProfitable" },
      ],
      rangeDate: null,
      myObj: {
        id: 0,
        name: "",
        father_name: "",
        age: "",
        contact: "",
        email: "",
        address: "",
        purpose: "",
        tag: "",
        date: new Date().toJSON(),
        attachments: "",
        campusID: this.$store.state.userData.cId,
        cls: 0,
        sec: 0,
        cnic: "",
        nextFollowup: new Date().toJSON(),
        inquiryType: "",
        inquiryStatus: "pending",
        referenceID: 0,
        referenceOther: "",
        lastSchool: "",
        residentialArea: "",
        note: "",
        quotation: null,
        priorityID: 0,
        statusID: 0,
        activityID: 0,
        categoryID: 0,
        tagID: 0,
        sessionID: 0,
        handledBy: "",
        lastMonthlyFee: "",
        studyingSince: "",
        visitingTime: "",
        meetingWith: "",
        finalRemarks: "",
        currentClass: "",
        dob: defaultInquiryDob(),
        learningDifficulties: "",
        specialMedicalNeeds: "",
        father_occupation: "",
        mother_occupation: "",
        father_cnic: "",
        mother_cnic: "",
      },
      referenceData: [],
      referenceOtherText: "",
      notification: this.$store.state.inqNotification,
      attachList: [],
      checkObj: {
        id: 0,
        title: "",
        details: "",
        campusID: this.$store.state.userData.cId,
      },
      accIcon: "",
      allChecklist: [],
      saving: false,
      detailObj: {},
      avatarURL:
        "https://raw.githubusercontent.com/Ashwinvalento/cartoon-avatar/master/lib/images/female/110.png",
      searchDate: "",
      config: {
        altFormat: "j M, Y",
        altInput: true,
        dateFormat: "Y-m-d",
      },
      config2: {
        noCalendar: true,
        enableTime: true,
        altFormat: "h:i K",
        altInput: true,
        dateFormat: "H:i:S",
        defaultHour: 8,
      },

      uploadFields: {
        Name: "name",
        Father: "father_name",
        Contact: "contact",
        Email: "email",
        Purpose: "purpose",
        Tag: "tag",
        Date: "date",
      },
      exporting: false,
      clikced: 1,
      dropOptions: {
        disabled: false,
        showDialCodeInList: true,
        showFlags: true,
      },
      reportDomain: this.$store.state.report.replace(/_/g, ""),
      sessionData: [],
      sbObj: null,
      siblingInfo: [],
    };
  },
  methods: {
    ...mapActions({ getDepartment: "getDepartment" }),
    ...mapActions({ get: "get", post: "post", put: "put", delete: "delete" }),

    handleEvent(event) {
      if (event.ctrlKey && event.keyCode === 83) {
        // console.log(event);
        event.preventDefault();
        if (this.clikced == 1) {
          this.clikced = 0;
          this.Add();
        }
      }
    },
    onDobChange(selectedDates, dateStr) {
      const selectedDate = selectedDates && selectedDates[0];
      if (!selectedDate && !dateStr) {
        this.myObj.age = "";
        return;
      }

      const dob = selectedDate || new Date(dateStr);
      if (Number.isNaN(dob.getTime())) {
        this.myObj.age = "";
        return;
      }

      const today = new Date();
      let age = today.getFullYear() - dob.getFullYear();
      const monthDiff = today.getMonth() - dob.getMonth();
      if (
        monthDiff < 0 ||
        (monthDiff === 0 && today.getDate() < dob.getDate())
      ) {
        age -= 1;
      }
      this.myObj.age = age >= 0 ? String(age) : "";
    },
    isImage(url) {
      return isImageUrl(url);
    },
    openFile(url) {
      window.open(
        isImageUrl(url) ? getMediaPreviewUrl(url, "Image") : url,
        "_blank"
      );
    },
    addSibling() {
      this.siblingInfo.push({
        id: 0,
        localID: this.myObj.id,
        type: "inquiry",
        name: "",
        relation: "",
        schoolName: "",
        age: "",
        className: "",
        campusID: this.myObj.campusID,
      });
    },
    async removeSibling(item, idx) {
      if (item.id == 0) {
        this.siblingInfo.splice(idx, 1);
      } else {
        var status = await this.delete({
          url:
            this.$store.state.domain +
            "SiblingDetails/" +
            item.id +
            "?db=" +
            this.$store.state.userData.db,
          body: null,
          grading: true,
          context: this,
          token: this.$store.state.userData.token,
        });
        if (status) this.siblingInfo.splice(idx, 1);
      }
    },
    AddDesc() {
      this.followObj.push({
        id: 0,
        inquiryID: this.currentInq,
        campusID: this.$store.state.userData.cId,
        date: new Date().toJSON(),
        followupBy: "",
        note: "",
      });
      // console.log(this.followObj);
    },
    async removeDesc(item, ind) {
      if (item.id == 0) {
        this.followObj.splice(ind, 1);
        // console.log(this.followObj);
      } else {
        var status = await this.delete({
          url:
            this.$store.state.domain +
            "InquiryFollowups/" +
            item.id +
            "?db=" +
            this.$store.state.userData.db,
          body: null,
          grading: true,
          context: this,
          token: this.$store.state.userData.token,
        });
        if (status) this.followObj.splice(ind, 1);
        // console.log(this.followObj);
      }
    },
    CheckValues() {
      let state = true;
      this.followObj.forEach((el) => {
        if (el.date == "" || el.note.trim() == "" || el.followupBy == "") {
          state = false;
        }
      });
      return state;
    },
    async Save() {
      // console.log("obj:", this.checkObj);
      if (this.checkTitle() == true) {
        this.saving = true;

        if (this.checkObj.id == 0) {
          var status = await this.post({
            url:
              this.$store.state.domain +
              "InquiryChecklist?db=" +
              this.$store.state.userData.db,
            body: this.checkObj,
            message: "Checklist added successfully.",
            context: this,
            token: this.$store.state.userData.token,
          });
          this.saving = false;
        } else {
          var status = await this.put({
            url:
              this.$store.state.domain +
              "InquiryChecklist/" +
              this.checkObj.id +
              "?db=" +
              this.$store.state.userData.db,
            message: "Checklist updated successfully.",
            context: this,
            body: this.checkObj,
            token: this.$store.state.userData.token,
          });
          this.saving = false;
        }
        if (status) {
          this.loadChecklist(1);
          var elem = this.$refs["title"];
          elem.state = undefined;
          this.checkObj = {
            id: 0,
            title: "",
            details: "",
            campusID: this.$store.state.userData.cId,
          };
          this.accIcon = "PlusIcon";
        }
      }
    },
    setNoti() {
      this.$store.commit("setInquiry", this.notification);
    },
    deleteDocument(index) {
      this.attachList.splice(index, 1);
      // console.log("list", this.attachList);
      this.myObj.attachments = this.attachList.join(",");
    },
    async PsampleAdd() {
      if (this.$refs.psamplefile.files.length !== 0) {
        this.mydocloading = true;
        this.saveDisable = true;
        try {
          const uploaded = await uploadToMySkool(this.$refs.psamplefile.files);
          getUploadedPaths(uploaded).forEach((path) => {
            this.attachList.push(path);
          });
          this.myObj.attachments = this.attachList.join(",");
        } catch (error) {
          console.log(error);
        } finally {
          this.mydocloading = false;
          this.saveDisable = false;
          if (this.$refs.psamplefile) this.$refs.psamplefile.value = "";
        }
      }
    },
    filterInquiry() {
      console.log(this.searchDate);
    },
    EditDep(row) {
      // console.log("myRow",row);
      this.depObj.id = row.id;
      this.depObj.name = row.name;
      this.depObj.campusID = this.$store.state.userData.cId;
      this.visibility1 = true;
      this.sidebarTitle = "Edit Department";
      this.sidebarButton = "Update";
      var elem = this.$refs["depname"];
      elem.state = undefined;
    },
    OpenDepartmentF() {
      this.visibility1 = true;
      this.depObj.id = 0;
      this.depObj.name = "";
      this.depObj.campusID = this.$store.state.userData.cId;
      this.sidebarTitle = "Add Department";
      this.sidebarButton = "Save";
      var elem = this.$refs["depname"];
      elem.state = undefined;
    },
    async Edit(id) {
      var obj = {
        url:
          this.$store.state.domain +
          "StudentInquiries/GetSelected?id=" +
          id +
          "&db=" +
          this.$store.state.userData.db,
        token: this.$store.state.userData.token,
      };
      this.myObj = await this.get(obj);
      this.myObj.dob = ensureInquiryDob(this.myObj.dob);
      if (this.myObj.sec === null || this.myObj.sec === undefined) {
        this.myObj.sec = 0;
      }
      console.log("editObj:", this.myObj);
      if (this.myObj.attachments !== null && this.myObj.attachments !== "") {
        this.attachList = this.myObj.attachments.split(",");
        // console.log(this.attachList);
      } else this.attachList = [];
      if (this.isHasanIslamicInquiry && this.myObj.cls) {
        this.syncSectionsForClass(false);
      }

      // var elem = this.$refs["name"];
      // elem.state = undefined;
      // var elem = this.$refs["fname"];
      // elem.state = undefined;
      // this.contacterror = false;
      // var elem = this.$refs["email"];
      // elem.state = undefined;
      // var elem = this.$refs["purpose"];
      // elem.state = undefined;
      // var elem = this.$refs["tag"];
      // elem.state = undefined;
    },
    setChecklist() {
      if (
        this.$route.params.id == 0 ||
        this.$route.params.id == -1 ||
        !this.$route.params.id.checklist
      ) {
        // console.log("not");
        this.formattedCL = this.allChecklist.map((item) => ({
          id: 0,
          inquiryID: this.currentInq,
          campusID: this.$store.state.userData.cId,
          checklistID: item.id,
          checkListData: false,
          title: item.title,
        }));
      } else {
        // console.log("in");
        let data = [];
        this.allChecklist.forEach((el) => {
          let item = this.$route.params.id.checklist.find(
            (ch) => ch.checklistID == el.id
          );
          if (item) {
            item.title = item.meta_text;
            data.push(item);
          } else {
            data.push({
              id: 0,
              inquiryID: this.currentInq,
              campusID: this.$store.state.userData.cId,
              checklistID: el.id,
              checkListData: false,
              title: el.title,
            });
          }
        });
        this.formattedCL = data;
      }
      // console.log(this.formattedCL);
    },
    async loadChecklist(num) {
      this.allChecklist = await this.get({
        url:
          this.$store.state.domain +
          "InquiryChecklist?db=" +
          this.$store.state.userData.db +
          "&cID=" +
          this.$store.state.userData.cId,
        token: this.$store.state.userData.token,
      });
      // console.log(this.allChecklist);
      if (num == 0) {
        this.setChecklist();
      } else {
        let data = [];
        this.allChecklist.forEach((el) => {
          let item = this.formattedCL.find((ch) => ch.checklistID == el.id);
          if (item) {
            data.push({
              id: item.id,
              inquiryID: item.inquiryID,
              campusID: this.$store.state.userData.cId,
              checklistID: item.checklistID,
              checkListData: item.checkListData,
              title: el.title,
            });
          } else {
            data.push({
              id: 0,
              inquiryID: this.currentInq,
              campusID: this.$store.state.userData.cId,
              checklistID: el.id,
              checkListData: false,
              title: el.title,
            });
          }
        });

        this.formattedCL = data;
        // console.log(this.formattedCL);
      }
    },
    AddOpen() {
      this.accIcon = "PlusIcon";
      this.checkObj = {
        id: 0,
        title: "",
        details: "",
        campusID: this.$store.state.userData.cId,
      };

      this.visibility = true;
      var elem = this.$refs["title"];
      elem.state = undefined;
    },
    async editCL(item) {
      this.checkObj = { ...item };
      this.accIcon = "Edit2Icon";
      var elem = this.$refs["title"];
      elem.state = undefined;
      // console.log(this.checkObj);
    },

    async deleteCL(item) {
      // console.log(acc);
      let result = await Swal.fire({
        title: this.$t("Are you sure?"),
        text: this.$t("You won't be able to revert this!"),
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#d33",
        cancelButtonColor: "#3085d6",
        confirmButtonText: this.$t("Yes, Delete it!"),
      });

      if (result.isConfirmed) {
        var status = await this.delete({
          url:
            this.$store.state.domain +
            "InquiryChecklist/" +
            item.id +
            "?db=" +
            this.$store.state.userData.db,

          message: "Checklist deleted successfully.",
          context: this,
          token: this.$store.state.userData.token,
        });
        if (status) this.loadChecklist(1);
      }
    },

    CheckMobile(s, e) {
      if (this.myObj.contact != "") {
        if (e.valid) {
          this.contacterror = false;
          this.myObj.contact = e.number;
          // console.log(this.myObj.contact);
        } else {
          this.contacterror = true;
        }
      } else {
        this.contacterror = false;
      }
      // console.log(this.myObj.contact.length);
      // if (this.myObj.contact.length == 12) {
      //   return (this.contacterror = false);
      // } else {
      //   return (this.contacterror = true);
      // }
    },
    CheckEmail() {
      var elem = this.$refs["email"];
      var re =
        /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

      if (
        re.test(String(this.myObj.email).toLowerCase()) &&
        this.myObj.email !== ""
      ) {
        return (elem.state = true);
      } else {
        return (elem.state = false);
      }
    },
    CheckFName() {
      var elem = this.$refs["fname"];
      if (this.myObj.father_name == "") {
        return (elem.state = false);
      } else {
        return (elem.state = true);
      }
    },
    CheckName() {
      var elem = this.$refs["name"];
      if (this.myObj.name == "") {
        return (elem.state = false);
      } else {
        return (elem.state = true);
      }
    },
    CheckClass() {
      if (
        this.myObj.inquiryType == "inquiry" ||
        this.showCrestViewGradeFields
      ) {
        var elem = this.$refs["class"];
        if (!elem) return true;
        if (this.myObj.cls == 0) {
          return (elem.state = false);
        } else {
          return (elem.state = true);
        }
      } else return true;
    },
    onClassSelected() {
      this.CheckClass();
      if (this.isHasanIslamicInquiry) {
        this.syncSectionsForClass(true);
        this.checkSection();
      }
    },
    syncSectionsForClass(clearSection = false) {
      const row = (this.classRows || []).find(
        (el) => el.cls && el.cls.id === this.myObj.cls
      );
      this.sectionOptions =
        row && Array.isArray(row.sections) ? row.sections : [];
      if (clearSection) {
        this.myObj.sec = 0;
        return;
      }
      const sec = this.myObj.sec;
      if (!sec) {
        return;
      }
      const byId = this.sectionOptions.some((s) => s.id == sec);
      if (byId) {
        return;
      }
      const byName = this.sectionOptions.find(
        (s) => s.section === sec || s.name === sec
      );
      if (byName) {
        this.myObj.sec = byName.id;
        return;
      }
      this.myObj.sec = 0;
    },
    checkSection() {
      if (!this.isHasanIslamicInquiry) {
        return true;
      }
      const elem = this.$refs["section"];
      if (!elem) {
        return true;
      }
      if (!this.sectionOptions.length) {
        elem.state = undefined;
        return true;
      }
      if (!this.myObj.sec) {
        return (elem.state = false);
      }
      return (elem.state = true);
    },
    CheckLast() {
      if (this.myObj.inquiryType == "inquiry") {
        var elem = this.$refs["last_school"];
        if (!this.myObj.lastSchool) {
          return (elem.state = false);
        } else {
          return (elem.state = true);
        }
      } else return true;
    },
    CheckPurpose() {
      var elem = this.$refs["purpose"];
      if (this.myObj.purpose == "") {
        return (elem.state = false);
      } else {
        return (elem.state = true);
      }
    },
    CheckTag() {
      var elem = this.$refs["tag"];
      if (this.myObj.tag == "") {
        return (elem.state = false);
      } else {
        return (elem.state = true);
      }
    },
    hideSideBar() {
      this.visibility = false;
      //  this.$refs.mysidebar.hide();
      //this.$bvModal.hide("modal-login");
    },
    hideDepSideBar() {
      this.visibility1 = false;
      //  this.$refs.mysidebar.hide();
      //this.$bvModal.hide("modal-login");
    },
    Form() {
      this.$router.push("/apps/schoolinfo");
    },
    checkTitle() {
      var elem = this.$refs["title"];
      if (this.checkObj.title === "") {
        return (elem.state = false);
      } else {
        return (elem.state = true);
      }
    },

    checkStatus() {
      if (this.myObj.Status == "") {
        return (this.errors.status = true);
      } else {
        return (this.errors.status = false);
      }
    },
    OpenAddModal() {
      this.$bvModal.show("modal-login");
      this.myObj.flavourId = 0;
      this.myObj.vendorId = this.$store.state.userData.userID;
      this.myObj.Name = "";
      this.myObj.Status = "";
    },
    OpenEditModal(row) {
      this.$bvModal.show("modal-login");
      this.myObj.flavourId = row.flavourId;
      this.myObj.vendorId = row.vendorId;
      this.myObj.Name = row.Name;
      this.myObj.Status = row.Status;
    },

    async Delete(id) {
      let result = await Swal.fire({
        title: this.$t("Are you sure?"),
        text: this.$t("You won't be able to revert this!"),
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#d33",
        cancelButtonColor: "#3085d6",
        confirmButtonText: this.$t("Yes, Delete it!"),
      });

      if (result.isConfirmed) {
        var status = await this.delete({
          url:
            this.$store.state.domain +
            "studentinquiries/" +
            id +
            "?db=" +
            this.$store.state.userData.db,
          message: "Inquiry deleted successfully.",
          context: this,
          body: null,
          token: this.$store.state.userData.token,
        });
        if (status) this.LoadData();
      }
    },

    CheckReferenceOther() {
      if (!this.showReferenceOtherInput) {
        return true;
      }

      const elem = this.$refs["reference_other"];
      if (!elem) {
        return true;
      }

      if (!this.referenceOtherText) {
        return (elem.state = false);
      }

      return (elem.state = true);
    },
    markFieldState(refName, isValid) {
      const elem = this.$refs[refName];
      if (elem) {
        elem.state = isValid;
      }
      return isValid;
    },
    hasRequiredValue(value) {
      if (value === null || value === undefined) {
        return false;
      }
      if (typeof value === "number") {
        return value !== 0;
      }
      if (typeof value === "string") {
        return value.trim() !== "";
      }
      return true;
    },
    checkReference() {
      if (!this.requireCrestViewFields) {
        return true;
      }

      const elem = this.$refs["refer"];
      if (!elem) {
        return true;
      }

      const isValid =
        this.myObj.referenceID !== null &&
        this.myObj.referenceID !== undefined &&
        this.myObj.referenceID !== 0;
      elem.state = isValid;
      return isValid;
    },
    validateCrestViewFields() {
      if (!this.requireCrestViewFields) {
        return true;
      }

      let isValid = true;
      const requireField = (refName, value) => {
        const fieldValid = this.hasRequiredValue(value);
        if (!this.markFieldState(refName, fieldValid)) {
          isValid = false;
        }
      };

      requireField("current_class", this.myObj.currentClass);
      requireField("dob", this.myObj.dob);
      requireField("age", this.myObj.age);
      requireField("learning_difficulties", this.myObj.learningDifficulties);
      requireField("special_medical_needs", this.myObj.specialMedicalNeeds);
      requireField("area", this.myObj.residentialArea);

      if (!this.CheckEmail()) {
        isValid = false;
      }
      if (!this.checkReference()) {
        isValid = false;
      }
      if (!this.CheckReferenceOther()) {
        isValid = false;
      }

      if (this.myObj.inquiryType === "inquiry") {
        requireField("date", this.myObj.date);
        requireField("purpose", this.myObj.purpose);
        requireField("tag", this.myObj.tag);
        requireField("next_date", this.myObj.nextFollowup);
        requireField("inq_note", this.myObj.note);
        requireField("final_remark", this.myObj.finalRemarks);
        requireField("father_occupation", this.myObj.father_occupation);
        requireField("mother_occupation", this.myObj.mother_occupation);
        requireField("father_cnic", this.myObj.father_cnic);
        requireField("mother_cnic", this.myObj.mother_cnic);
        requireField("session", this.myObj.sessionID);
        requireField("last_school", this.myObj.lastSchool);
        requireField("last_fee", this.myObj.lastMonthlyFee);
        requireField("studying_since", this.myObj.studyingSince);
      }

      if (this.myObj.inquiryType === "visitor") {
        requireField("date", this.myObj.date);
        requireField("visiting_time", this.myObj.visitingTime);
        requireField("purpose", this.myObj.purpose);
        requireField("tag", this.myObj.tag);
        requireField("next_date", this.myObj.nextFollowup);
        requireField("meeting_with", this.myObj.meetingWith);
        requireField("inq_note", this.myObj.note);
        requireField("final_remark", this.myObj.finalRemarks);

        const docsValid =
          Array.isArray(this.attachList) && this.attachList.length > 0;
        if (!this.markFieldState("docs", docsValid)) {
          isValid = false;
        }
      }

      return isValid;
    },
    prepareCrestViewReferenceForSave() {
      if (!this.isCrestViewAcademy) {
        return;
      }

      if (this.myObj.referenceID === CRESTVIEW_REFERENCE_OTHER_ID) {
        const otherRef = this.referenceData.find(
          (item) => item.name && item.name.toLowerCase() === "other"
        );
        this.myObj.referenceID = otherRef ? otherRef.id : 0;
        this.myObj.referenceOther = this.referenceOtherText.trim();
        return;
      }

      this.myObj.referenceOther = "";
    },
    applyCrestViewReferenceState() {
      if (!this.isCrestViewAcademy) {
        return;
      }

      if (this.myObj.referenceOther) {
        this.referenceOtherText = this.myObj.referenceOther;
        this.myObj.referenceID = CRESTVIEW_REFERENCE_OTHER_ID;
        return;
      }

      const otherRef = this.referenceData.find(
        (item) => item.name && item.name.toLowerCase() === "other"
      );
      if (otherRef && this.myObj.referenceID === otherRef.id) {
        this.myObj.referenceID = CRESTVIEW_REFERENCE_OTHER_ID;
      }
    },

    async Add() {
      // let data = {
      //   inquiry: this.myObj,
      //   checklist: this.formattedCL,
      //   followups: this.followObj,
      // };
      // console.log(data);
      // return true;
      this.CheckName();
      this.CheckFName();
      this.CheckClass();
      if (this.isHasanIslamicInquiry) {
        this.checkSection();
      }
      this.CheckLast();
      this.CheckReferenceOther();
      const crestViewValid = this.validateCrestViewFields();
      // this.CheckEmail();
      // this.CheckPurpose();
      // this.CheckTag();
      if (!this.myObj.contact) this.contacterror = true;
      if (
        this.CheckName() == false ||
        this.contacterror ||
        // this.CheckValues() == false
        this.CheckFName() == false ||
        this.CheckClass() == false ||
        (this.isHasanIslamicInquiry && this.checkSection() == false) ||
        this.CheckLast() == false ||
        this.CheckReferenceOther() == false ||
        crestViewValid == false
        // this.CheckEmail() == false ||
        // this.CheckPurpose() == false ||
        // this.CheckTag() == false
      ) {
        this.$bvToast.toast(this.$t("Please fill the form correctly."), {
          title: this.$t("Error!"),
          variant: "danger",
          toaster: "b-toaster-top-center",
        });
        this.clikced = 1;
      } else {
        this.request = true;
        this.myObj.notification = this.notification;
        if (
          this.myObj.id > 0 &&
          (!this.myObj.inquiryStatus || this.myObj.inquiryStatus == "pending")
        ) {
          this.myObj.inquiryStatus = "in progress";
        }

        const sibData = this.siblingInfo.filter(
          (el) => el.id > 0 || (el.id == 0 && el.name.trim() != "")
        );

        this.myObj.dob = ensureInquiryDob(this.myObj.dob);
        this.prepareCrestViewReferenceForSave();

        let data = {
          inquiry: this.myObj,
          checklist: this.formattedCL,
          followups: this.followObj,
          siblings: sibData,
        };
        //studentinquiries/Save
        var status = await this.post({
          url:
            this.$store.state.domain +
            "studentinquiries/SaveWithSibling?db=" +
            this.$store.state.userData.db +
            "&cID=" +
            this.$store.state.userData.cId +
            "&sms=" +
            this.notification,
          body: data,
          message: this.$t("Inquiry saved successfully."),
          context: this,
          token: this.$store.state.userData.token,
        });
        this.request = false;
        //this.visibility1 = false;
        if (status) {
          this.$router.go(-1);
        }
      }
    },

    async LoadData() {
      let page = this.currentPage;
      this.byFilter = false;
      this.dataLoading = true;
      this.items = [];
      let myitem = await this.get({
        url:
          this.$store.state.domain +
          "studentinquiries?db=" +
          this.$store.state.userData.db +
          "&cId=" +
          this.$store.state.userData.cId,
        token: this.$store.state.userData.token,
      });
      // console.log(myitem);
      this.items = myitem;

      // myitem.forEach((elem) => {
      //   var d = new Date(elem.date);
      //   elem.date = d.toDateString();
      //   //  elem.date =  elem.date.split("T")[0];
      //   this.items.push(elem);
      // });
      // if (this.items.length != 0) {
      //   this.totalRows = this.items.length;
      // }
      this.dataLoading = false;
      setTimeout(() => {
        this.currentPage = page;
      }, 100);
    },
    async LoadFilter() {
      this.byFilter = true;
      this.dataLoading = true;
      var status = await this.post({
        url: this.$store.state.domain + "studentinquiries/Filter",
        body: this.filter,
        subjects: true,
        context: this,
        token: this.$store.state.userData.token,
      });
      // this.request = false;
      this.$bvModal.hide("modal-login");
      // console.log(status);
      this.items = status;
      this.dataLoading = false;
    },
    async FilterInit() {
      this.filterLoading = true;
      var obj = {
        url:
          this.$store.state.domain +
          "StudentInquiries/FilterInit?db=" +
          this.$store.state.userData.db +
          "&cID=" +
          this.$store.state.userData.cId,
        token: this.$store.state.userData.token,
      };
      //  this.items =[];
      let res = await this.get(obj);
      // console.log(res);
      this.filterTags = res.tags;
      this.filterClasses = res.cls;
      this.filterLoading = false;
      this.$bvModal.show("modal-login");
    },
    async LoadClasses() {
      let obj = {
        url:
          this.$store.state.domain +
          "myclasses/LoadClasses?db=" +
          this.$store.state.userData.db +
          "&cId=" +
          this.$store.state.userData.cId +
          "&dID=0",
        token: this.$store.state.userData.token,
      };

      if (this.reportDomain == "myskoolhpgs") {
        obj = {
          url:
            this.$store.state.domain +
            "myclasses/LoadClassesAll?db=" +
            this.$store.state.userData.db +
            "&cId=" +
            this.$store.state.userData.cId +
            "&dID=0",
          token: this.$store.state.userData.token,
        };
      }

      let myItems = await this.get(obj);
      this.classRows = Array.isArray(myItems) ? myItems : [];
      this.classes = this.classRows.map((el) => el.cls);
      if (this.isHasanIslamicInquiry && this.myObj.cls) {
        this.syncSectionsForClass(false);
      }
    },
    async loadRefs() {
      this.referenceData = await this.get({
        url:
          this.$store.state.domain +
          "InquiryReferrence?db=" +
          this.$store.state.userData.db +
          "&cId=" +
          this.$store.state.userData.cId,
        token: this.$store.state.userData.token,
      });
      this.applyCrestViewReferenceState();
    },
    async LoadSession() {
      this.sessionData = await this.get({
        url:
          this.$store.state.domain +
          "Sessions?db=" +
          this.$store.state.userData.db +
          "&cId=" +
          this.$store.state.userData.cId,
        token: this.$store.state.userData.token,
      });

      if (this.showCrestViewInquiryFields && this.myObj.id == 0) {
        const crestViewSession = this.sessionData.find(
          (item) =>
            item.session &&
            String(item.session).includes(CRESTVIEW_DEFAULT_SESSION)
        );
        if (crestViewSession) {
          this.myObj.sessionID = crestViewSession.id;
          return;
        }
      }

      const currentSession = this.sessionData.find(
        (el) => el.isCurrentSession == true
      );
      if (
        this.myObj.id == 0 &&
        this.myObj.inquiryType == "inquiry" &&
        currentSession
      ) {
        this.myObj.sessionID = currentSession.id;
      }
    },
    async LoadUsers() {
      this.userLoading = true;
      var obj = {
        url:
          this.$store.state.domain +
          "Users/LoadUsers?db=" +
          this.$store.state.userData.db +
          "&cID=" +
          this.$store.state.userData.cId,
        token: this.$store.state.userData.token,
      };
      this.allUsers = await this.get(obj);
      // console.log(this.allUsers);
      this.userLoading = false;
    },
    async LoadSettingsAll() {
      let res = await this.post({
        url:
          this.$store.state.domain +
          "Settings/getSettingsAll?db=" +
          this.$store.state.userData.db,
        body: ["sibling_details"],
        context: this,
        token: this.$store.state.userData.token,
        subjects: true,
      });
      this.sbObj = res.find((el) => el.key == "sibling_details");
      if (this.sbObj && this.sbObj.valueBool && this.myObj.id > 0) {
        this.LoadSibling();
      }
    },
    async LoadSibling() {
      const res = await this.get({
        url:
          this.$store.state.domain +
          "SiblingDetails/LoadData?db=" +
          this.$store.state.userData.db +
          "&id=" +
          this.myObj.id +
          "&type=inquiry",
        token: this.$store.state.userData.token,
      });
      this.siblingInfo = res;
    },
  },
};
</script>

<style lang="scss" scoped>
.per-page-selector {
  width: 90px;
}
</style>

<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";
@import "@core/scss/vue/libs/vue-flatpicker.scss";
</style>
<style scoped>
.border-dashed {
  border: 1px solid var(--primary);
  border-style: dashed;
}
.image {
  float: left;
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center center;
  border: 1px solid #ebebeb;
  margin: 5px;
}
.card {
  transition: 0.4s;
}
.card:hover {
  box-shadow: 0 8px 16px 0 rgba(0, 0, 0, 0.2);
}
</style>
